// Contact.js
import React from 'react';
import { useScrollAnimation } from '../animations/ScrollAnimation';

const Contact = () => {
  useScrollAnimation();
  
  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <h2 className="section-title appear">聯絡我</h2>
        
        <div className="contact-grid">
          <div className="contact-info appear">         
            <div className="social-links">
              <a href="https://www.instagram.com/dzhkqn/#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://github.com/yuxian1315" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://www.facebook.com/yuniennn" target="_blank" rel="noopener noreferrer" aria-label="Behance">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="mailto:contact@mail.dzhkqn.studio" target="_blank" rel="noopener noreferrer" aria-label="Behance">
                <i className="fa-solid fa-envelope"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;